/* Max Bassi - pagina prodotto.
   Scritto senza nessun carattere di escape per evitare problemi di caricamento. */
(function () {
  function mbInitProduct() {
    var root = document.querySelector('[data-mb-product]');
    if (!root || root.dataset.mbBound) return;
    root.dataset.mbBound = '1';

    var gallery = root.querySelector('[data-mb-gallery]');
    var track = gallery && gallery.querySelector('[data-mb-track]');
    var slides = gallery ? gallery.querySelectorAll('[data-mb-slide]') : [];
    var thumbs = gallery ? gallery.querySelectorAll('[data-mb-thumb-i]') : [];
    var mbCurrent = 0;

    function mbSetActiveSlide(i) {
      mbCurrent = parseInt(i, 10) || 0;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-mb-thumb-i') === String(mbCurrent)); });
    }

    function mbGoTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      mbSetActiveSlide(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { mbGoTo(parseInt(t.getAttribute('data-mb-thumb-i'), 10)); });
    });

    if (gallery) gallery.querySelectorAll('[data-mb-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () { mbGoTo(mbCurrent + parseInt(btn.getAttribute('data-mb-nav'), 10)); });
    });

    if (track && slides.length && 'IntersectionObserver' in window) {
      var gio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.55) mbSetActiveSlide(en.target.getAttribute('data-mb-slide'));
        });
      }, { root: track, threshold: [0.55] });
      slides.forEach(function (s) { gio.observe(s); });
    }

    var qtyInput = root.querySelector('.mb-product__qty-input');
    root.querySelectorAll('[data-mb-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(b.getAttribute('data-mb-qty'), 10);
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val + step);
      });
    });

    var dataEl = root.querySelector('[data-mb-variant-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var idInput = root.querySelector('[data-mb-variant-id]');
    var priceWrap = root.querySelector('[data-mb-price]');
    var addBtn = root.querySelector('[data-mb-add]');
    var addText = root.querySelector('[data-mb-add-text]');

    function selectedOptions() {
      var inputs = root.querySelectorAll('[data-mb-opt-input]:checked');
      return Array.prototype.map.call(inputs, function (i) { return i.value; });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var opts = selectedOptions();
      if (!opts.length) return;
      var v = findVariant(opts);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceWrap) {
        var html = '<span class="mb-product__price-now">' + v.price + '</span>';
        if (v.compare_at) html += '<span class="mb-product__price-was">' + v.compare_at + '</span>';
        priceWrap.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText) addText.textContent = v.available ? v.available_text : v.soldout_text;
      }
      var stPrice = root.querySelector('[data-mb-sticky-price]');
      if (stPrice) stPrice.textContent = v.price;
      var stBtn = root.querySelector('[data-mb-sticky-add]');
      var stText = root.querySelector('[data-mb-sticky-add-text]');
      if (stBtn) { stBtn.disabled = !v.available; if (stText) stText.textContent = v.available ? v.available_text : v.soldout_text; }
    }

    root.querySelectorAll('[data-mb-opt-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var fs = input.closest('.mb-product__opt');
        if (fs) fs.querySelectorAll('.mb-product__pill').forEach(function (l) { l.classList.remove('is-selected'); });
        var lbl = input.closest('.mb-product__pill');
        if (lbl) lbl.classList.add('is-selected');
        update();
      });
    });

    var ppSample = root.querySelector('[data-mb-sample-btn]');
    if (ppSample) {
      var ppSetAdded = function () {
        if (ppSample.dataset.state !== 'adding') return;
        var icon = ppSample.querySelector('[data-mb-sample-icon]');
        var label = ppSample.querySelector('[data-mb-sample-label]');
        ppSample.dataset.state = 'added';
        if (icon) icon.className = 'fa-solid fa-check';
        if (label) label.textContent = 'Aggiunto al carrello';
        setTimeout(function () {
          ppSample.dataset.state = '';
          if (icon) icon.className = 'fa-solid fa-plus';
          if (label && ppSample.dataset.mbOriginalLabel) label.textContent = ppSample.dataset.mbOriginalLabel;
        }, 2200);
      };
      ppSample.addEventListener('click', function () {
        if (ppSample.dataset.state === 'adding' || ppSample.dataset.state === 'added' || ppSample.disabled) return;
        var label = ppSample.querySelector('[data-mb-sample-label]');
        if (label && !ppSample.dataset.mbOriginalLabel) ppSample.dataset.mbOriginalLabel = label.textContent;
        ppSample.dataset.state = 'adding';
        if (label) label.textContent = 'Aggiungo...';
        setTimeout(ppSetAdded, 1600);
      });
      ['cart:update', 'cart:change', 'CartUpdateEvent'].forEach(function (evName) {
        document.addEventListener(evName, ppSetAdded);
      });
    }

    var calcRoot = root.querySelector('[data-mb-calc]');
    var CALC_RESA = calcRoot ? (parseFloat(calcRoot.getAttribute('data-mb-resa')) || 7.5) : 7.5;

    if (calcRoot) {
      var calcToggle = calcRoot.querySelector('[data-mb-calc-toggle]');
      var calcBody = calcRoot.querySelector('[data-mb-calc-body]');
      var calcInput = calcRoot.querySelector('[data-mb-calc-input]');
      var calcBtn = calcRoot.querySelector('[data-mb-calc-btn]');
      var calcResult = calcRoot.querySelector('[data-mb-calc-result]');

      var DIGITS = '0123456789.';

      function parseLiters(text) {
        var raw = String(text || '').toLowerCase().trim().replace(',', '.');
        if (raw.indexOf('campion') > -1) return null;
        var i = 0;
        while (i < raw.length && DIGITS.indexOf(raw.charAt(i)) > -1) i++;
        if (i === 0) return null;
        var n = parseFloat(raw.slice(0, i));
        if (!n || n <= 0) return null;
        var rest = raw.slice(i).trim();
        if (rest.charAt(0) !== 'l') return null;
        return n;
      }

      function getFormats() {
        var groups = root.querySelectorAll('[data-mb-option]');
        var byName = null, byValues = null;

        groups.forEach(function (fs) {
          var nameEl = fs.querySelector('.mb-product__opt-name');
          var name = nameEl ? nameEl.textContent : '';
          var inputs = fs.querySelectorAll('[data-mb-opt-input]');
          var found = [];
          inputs.forEach(function (inp) {
            var liters = parseLiters(inp.value);
            if (liters) found.push({ liters: liters, input: inp });
          });

          if (found.length && /formato|litr|misura|dimensione|taglia|capacit/i.test(name)) {
            if (!byName || found.length > byName.length) byName = found;
          }
          if (found.length && (!byValues || found.length > byValues.length)) byValues = found;
        });

        var best = byName || byValues;
        return best ? best.sort(function (a, b) { return a.liters - b.liters; }) : [];
      }

      function fmtLt(n) {
        var s = (Math.round(n * 100) / 100).toString().replace('.', ',');
        return s + ' Lt';
      }

      function bestCombo(formats, needed) {
        var MAX_UNITS = 8;
        var best = null;

        function evaluate(counts) {
          var total = 0, units = 0, types = 0;
          var combo = [];
          counts.forEach(function (qty, i) {
            if (qty > 0) {
              total += qty * formats[i].liters;
              units += qty;
              types += 1;
              combo.push({ format: formats[i], qty: qty });
            }
          });
          if (total + 0.001 < needed) return;
          var waste = total - needed;
          if (
            !best ||
            waste < best.waste - 0.001 ||
            (Math.abs(waste - best.waste) < 0.001 && units < best.units) ||
            (Math.abs(waste - best.waste) < 0.001 && units === best.units && types < best.types)
          ) {
            best = { combo: combo, total: total, waste: waste, units: units, types: types };
          }
        }

        function recurse(i, counts) {
          if (i === formats.length) { evaluate(counts); return; }
          for (var q = 0; q <= MAX_UNITS; q++) {
            recurse(i + 1, counts.concat([q]));
          }
        }

        recurse(0, []);
        return best;
      }

      if (!getFormats().length) {
        calcRoot.style.display = 'none';
      } else {
        calcToggle.addEventListener('click', function () {
          var isOpen = !calcBody.hidden;
          calcBody.hidden = isOpen;
          calcRoot.classList.toggle('is-open', !isOpen);
        });

        calcBtn.addEventListener('click', function () {
          var mq = parseFloat((calcInput.value || '').replace(',', '.'));
          if (!mq || mq <= 0) {
            calcResult.hidden = false;
            calcResult.innerHTML = '<p class="mb-product__calc-err">Inserisci i metri quadri di parete.</p>';
            return;
          }

          var needed = mq / CALC_RESA;
          var formats = getFormats();

          if (!formats.length) {
            calcResult.hidden = false;
            calcResult.innerHTML = '<p class="mb-product__calc-err">Formato non disponibile per il calcolo su questo prodotto.</p>';
            return;
          }

          var result = bestCombo(formats, needed);
          if (!result) {
            calcResult.hidden = false;
            calcResult.innerHTML = '<p class="mb-product__calc-err">Quantità troppo alta da calcolare, contattaci per un preventivo.</p>';
            return;
          }

          var combo = result.combo.slice().sort(function (a, b) { return b.format.liters - a.format.liters; });
          var parts = combo.map(function (c) { return c.qty + ' × ' + fmtLt(c.format.liters); });

          var html = '<p class="mb-product__calc-need">Per ' + mq + ' m² a due mani ti servono circa <strong>' + fmtLt(needed) + '</strong>.</p>';
          html += '<p class="mb-product__calc-suggest">Formato consigliato: <strong>' + parts.join(' + ') + '</strong></p>';
          if (combo.length > 1) {
            html += '<button type="button" class="mb-btn mb-btn-primary mb-product__calc-addall" data-mb-calc-addall>Aggiungi tutti i formati consigliati</button>';
            html += '<p class="mb-product__calc-alt">Un click e copri tutta la superficie.</p>';
          }
          calcResult.hidden = false;
          calcResult.innerHTML = html;

          var addAllBtn = calcResult.querySelector('[data-mb-calc-addall]');
          if (addAllBtn) {
            addAllBtn.addEventListener('click', function () {
              var el = root.querySelector('[data-mb-variant-data]');
              if (!el) return;
              var vlist;
              try { vlist = JSON.parse(el.textContent); } catch (e) { return; }
              var items = [];
              combo.forEach(function (c) {
                var val = c.format.input.value;
                var v = vlist.find(function (x) { return x.available !== false && x.options.indexOf(val) > -1; });
                if (v) items.push({ id: v.id, quantity: c.qty });
              });
              if (items.length !== combo.length) {
                alert('Un formato consigliato non è disponibile al momento.');
                return;
              }

              addAllBtn.disabled = true;
              addAllBtn.textContent = 'Aggiungo...';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
              })
                .then(function (r) { if (!r.ok) throw new Error('add_error'); return r.json(); })
                .then(function () { window.location.href = '/cart'; })
                .catch(function () {
                  addAllBtn.disabled = false;
                  addAllBtn.textContent = 'Aggiungi tutti i formati consigliati';
                  alert('Qualcosa è andato storto, riprova.');
                });
            });
          }

          var main = combo[0];
          main.format.input.checked = true;
          main.format.input.dispatchEvent(new Event('change', { bubbles: true }));
          if (qtyInput) qtyInput.value = main.qty;
        });
      }
    }

    var sticky = root.querySelector('[data-mb-sticky]');
    var buyBox = root.querySelector('.mb-product__buy');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('mb-pp__sticky--show', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '-35% 0px 0px 0px' });
      so.observe(buyBox);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mbInitProduct);
  } else {
    mbInitProduct();
  }
  document.addEventListener('shopify:section:load', mbInitProduct);
})();
